import { TokenWithAmountForDatum, Token_With_Price_And_Date_And_Signature_And_Amount, Token_With_Price_And_Date_And_Signature_And_Amount_And_Metadata } from '../../Commons';
import { InvestUnitWithDetailsEntity } from '../../Entities/Invest.Unit.WithDetails.Entity';
import { PriceApi } from '../Price/Price.FrontEnd.Api.Calls';
import { TokenMetadataApi } from '../index.exports';
import { InvestUnitApi } from './Invest.Unit.FrontEnd.Api.Calls';

export class InvestUnitWithDetailsApi extends InvestUnitApi {
    protected static _Entity = InvestUnitWithDetailsEntity;

    // #region api

    // #endregion api
}
